import { render, staticRenderFns } from "./GeneralSpecialtyBtns.vue?vue&type=template&id=7faf76b6&"
import script from "./GeneralSpecialtyBtns.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtyBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports